module.exports = __webpack_public_path__ + "img/id-number-1.90398d6a.svg";